import React, { useEffect, useState } from "react";
import "./forget.css";
import help from "../../../img/undraw_add_friends_re_3xte.svg";
import { Fade } from "react-awesome-reveal";
import { TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../Notifcation";
import { ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { forgetPasswordAction } from "../../../redux/actions/AuthAction";
const Forget = () => {
  const [Phone, setPhone] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const dispatch = useDispatch();

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Phone === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      forgetPasswordAction({
        PhoneNumber: Phone,
        Message: "هذا الشخص نسى كلمة المرور",
      })
    );
    setLoading(false);
    setIsPress(false);
  };
  const res = useSelector((state) => state.authReducer.forgetPassword);
  useEffect(() => {
    if (loading === false) {
      if (res && res.data) {
        if (res.data.ResponseMessage === "Great, email sent Successfully") {
          notify(
            "تم تسجيل رقم الهاتف بنجاح برجاء الأنتظار وسيتم ارسال كلمة السر الجديدة عبر رسائل الهاتف",
            "success"
          );
        }
      } else {
        notify("الرجاء حاول مرة اخرى", "error");
      }
    }
  }, [loading, res]);
  return (
    <div className="help">
      <div className="container rounded bg-white mt-5 mb-5">
        <div className="row">
          <div className="col-md-6 border-right">
            <div className="p-3 py-5">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-center">هل نسيت كلمة السر</h4>
              </div>
              <div className="row mt-3">
                <div className="col-md-12 de">
                  {" "}
                  <TextField
                    value={Phone}
                    focused
                    onChange={(e) => setPhone(e.target.value)}
                    inputProps={{ maxLength: 15 }}
                    type="number"
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        رقم الهاتف
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                  />
                </div>{" "}
              </div>
              <div className="mt-5 text-center">
                {isPress && loading ? (
                  <button className=" profile-button">
                    <Spinner animation="border" role="status"></Spinner>
                  </button>
                ) : (
                  <button onClick={handlesubmit} className=" profile-button">
                    إرسال
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <Fade direction="left">
              <div className="p-3 py-5">
                <Fade direction="right">
                  <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                    <img
                      className="mt-5"
                      width="150px"
                      src={help}
                      alt="avatar"
                    />
                  </div>
                </Fade>
              </div>
            </Fade>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={1200} />
    </div>
  );
};

export default Forget;
